import { render, staticRenderFns } from "./cloudCollege.vue?vue&type=template&id=a48296be&scoped=true&"
import script from "./cloudCollege.vue?vue&type=script&lang=js&"
export * from "./cloudCollege.vue?vue&type=script&lang=js&"
import style0 from "./cloudCollege.vue?vue&type=style&index=0&id=a48296be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48296be",
  null
  
)

export default component.exports